export default function IconU2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      aria-hidden="true"
      role="presentation"
      focusable="false"
      className="icon-u2"
    >
      <path d="m6 6 20 20M26 6 6 26"></path>
    </svg>
  );
}
